import { Component, effect, ViewChild, inject } from '@angular/core';
import { ServiceSettingsAnamnesisStore } from './service-settings-anamnesis.store';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { ActivatedRoute, Router } from '@angular/router';
import { contentGlobalSuccess } from '../../../../content.error';
import {
    ServiceSettingsCommonComponent,
} from '../../../../components/services/settings/service-settings-common/service-settings-common.component';
import { SERVICE_SETTINGS_ANAMNESIS_TYPE_KEY } from '@libs/types/src/services/types/service-settings-anamnesis.type';
import { Divider } from '@openng/optimus-ui/divider';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-settings-anamnesis',
    templateUrl: './service-settings-anamnesis.component.html',
    providers: [ServiceSettingsAnamnesisStore],
    imports: [
        ServiceSettingsCommonComponent,
        Divider,
        CheckInputComponent,
        ActionButtonsComponent,
    ],
})
export class ServiceSettingsAnamnesisComponent {
    protected readonly store = inject(ServiceSettingsAnamnesisStore);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);


    @ViewChild(ServiceSettingsCommonComponent) serviceSettingsCommonComponent!: ServiceSettingsCommonComponent;

    form = fb.group({
        showHbsag: fb.control<boolean>(true),
        showHiv: fb.control<boolean>(true),
        showRw: fb.control<boolean>(true),
    });

    constructor() {
        effect(() => {
            const defaultValues = this.store.anamnesisSettings();
            if (defaultValues) {
                this.form.patchValue({
                    showHbsag: defaultValues?.showHbsag ?? true,
                    showHiv: defaultValues?.showHiv ?? true,
                    showRw: defaultValues?.showRw ?? true,
                });
            }
        });
    }

    save() {
        const serviceId = routeParams.serviceId();
        if (!serviceId) return;

        const data = {
            ...JSON.parse(this.serviceSettingsCommonComponent.getFormData()),
            showHbsag: Boolean(this.form.value.showHbsag),
            showHiv: Boolean(this.form.value.showHiv),
            showRw: Boolean(this.form.value.showRw),
        };

        this.store.api.updateServiceSettings({
            key: SERVICE_SETTINGS_ANAMNESIS_TYPE_KEY,
            data: JSON.stringify(data),
            serviceId: Number(serviceId),
        }).then(() => {
            contentGlobalSuccess.next('common.updated');
        });
    }

    async cancel() {
        this.router.navigate(['../../basic-information'], { relativeTo: this.route });
    }
}
